import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent } from '../fc';
/**
 * fc-layoutgroupåç»å¸å±
 * 
 * åç»å¸å±ã
 * 
 * å¤å±æè¾¹æ¡åºåå¯è®¾ç½®æ é¢ã
 * 
 */
@Component({
    selector: 'fc-layoutgroup',
    template: `
    <section   class="fc-layoutgroup" [ngClass]="{'fc-full':fcFull,fcClass:fcClass!==undefined}" [style.margin]="fcMargin">
        <div class="fc-header">
            <span>{{fcTitle}}</span>
        </div>
        <div class="fc-content">
            <ng-content select="[fccontent]" style="height:100%;"></ng-content>
        </div>
        <div class="fc-footer">
            <ng-content select="[fcfooter]"></ng-content>
        </div>
    </section>
    `,
    styles: [`
        .fc-layoutgroup {
            width: calc(100% - 20px);
            border: 1px solid #e9e9e9;
            position: relative;
        }
        .fc-layoutgroup .fc-header{
            font-size: 14px;
            color: #777;
            font-weight: 500;
            padding: 1px 8px;
            border-radius: 4px 4px 0 0;
            background: #ffffff;
            position:absolute;
            top: -14px;
            left:16px;
        }
        .fc-layoutgroup .fc-content {
            padding:10px;
        }
        .fc-full .fc-content{
            height:100%;
        }
        .fc-footer{
            border-top:1px 
        }
    `]
})
export class FclayoutgroupComponent extends FcComponent {
     /**å®½é«100%ç»§æ¿ä¸ä¸ä¸ªçå®½é«*/
    @Input()
    fcFull: boolean = false;
     /** æ é¢*/
    @Input()
    fcTitle: string;
     /**å¤è¾¹è·*/
    @Input()
    fcMargin: string = "15px 5px 5px";
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-layoutgroup');
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
    }
}
